<ng-template #overrideMpnFields let-modal>
  <div class="modal-header override-modal-header">
    <div class="override-modal-title">
      <div class="title-icon">
        <i class="far fa-file-alt"></i>
      </div>
      <div>
        <h2>Confirm</h2>
        <p>{{ app.text.field.fillThreadFieldsAutomatically }}</p>
      </div>
    </div>
    <button
      type="button"
      class="close-button"
      aria-label="Close"
      (click)="closeModal()"
      >
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="modal-body override-modal-body">
    @if (
      app.overrideMpnFields.selectedField === app.fieldId.thread.crtNumber ||
      app.overrideMpnFields.selectedField === app.fieldId.thread.artNumber
      ) {
      <div
        class="override-content"
        >
        @for (
          key of getManufacturerKeysWithValues(); track
          key; let first = $first) {
          @if (first) {
            <section class="primary-field">
              <div>
                <div class="field-label">
                  {{ app.field.getLabel(key) }}
                  <i class="fas fa-info-circle"></i>
                </div>
                <div class="field-warning">
                  {{ app.text.field.whereUsedPartNumber }}
                </div>
              </div>
              <div class="field-value hero-value">
                {{
                app.field.getFieldValueAsText(
                app.fieldId.thread.artNumber,
                app.thread.thread[app.fieldId.thread.artNumber]
                )
                }}
              </div>
            </section>
          }
        }
        <section class="next-step-card">
          <div class="next-step-title">
            <span><i class="fas fa-info"></i></span>
            {{ app.text.thread.overrideModalNextTitle }}
          </div>
          <p>{{ app.text.thread.overrideModalApplyMessage }}</p>
          <p>{{ app.text.thread.overrideModalReviewMessage }}</p>
        </section>
        <div class="assemblies-panel">
          <app-where-used-in [hideDisplayText]="true"></app-where-used-in>
        </div>
        @if (getPartKeysWithValues().length > 0) {
          <section class="field-grid">
            @for (key of getPartKeysWithValues(); track key) {
              <div class="field-card">
                <div class="field-icon"><i class="far fa-file-alt"></i></div>
                <div class="field-label">{{ app.field.getLabel(key) }}</div>
                <div class="field-value">
                  {{
                  app.field.getFieldValueAsText(
                  key,
                  app.manufacturer.selectedPart[key.split(".")[1]]
                  ) || "-"
                  }}
                </div>
              </div>
            }
          </section>
        }
        @if (getManufacturerKeysWithValues().length > 1) {
          <section
            class="field-grid"
            >
            @for (
              key of getManufacturerKeysWithValues(); track
              key; let first = $first) {
              @if (!first) {
                <div class="field-card">
                  <div class="field-icon"><i class="far fa-file-alt"></i></div>
                  <div class="field-label">{{ app.field.getLabel(key) }}</div>
                  <div class="field-value">
                    {{
                    app.field.getFieldValueAsText(
                    key,
                    app.manufacturer.selectedManufacturer[key.split(".")[1]]
                    ) || "-"
                    }}
                  </div>
                </div>
              }
            }
          </section>
        }
      </div>
    }
  </div>

  <div class="modal-footer override-modal-footer">
    <div class="footer-note">
      <i class="far fa-check-circle"></i>
      <span>{{ app.text.thread.overrideModalFooterMessage }}</span>
    </div>
    <button class="btn secondary-action" (click)="closeModal()">
      {{ app.text.modal.cancel }}
    </button>
    <button
      class="btn primary-action"
      (click)="
        app.overrideMpnFields.setFieldsOnThread(
          app.overrideMpnFields.selectedField
        );
        closeModal()
      "
      >
      {{ app.text.thread.overrideModalAddToCase }}
    </button>
  </div>
</ng-template>
